import React from "react";

const SVG = ({
  style = {},
  fill = "none",
  stroke = "#000",
  width = "24px",
  height = "24px",
  className = "",
  viewBox = "0 0 24 24"
}) => (
  <svg
    width={width}
    height={height}
    style={style}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
  >
    <circle cx="12" cy="13" r="8" stroke={stroke} strokeWidth="1.5" />
    <path d="M12 10V13.5L14.5 16" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9.5 3H14.5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
    <path d="M12 3V5" stroke={stroke} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);

export default SVG;
